import {
  FileText,
  CalendarDays,
  Users,
  CheckCircle2,
} from "lucide-react";

const tabs = [
  {
    id: "basic",
    label: "Basic Information",
    icon: FileText,
  },
  {
    id: "planning",
    label: "Planning",
    icon: CalendarDays,
  },
 
  {
    id: "review",
    label: "Review",
    icon: CheckCircle2,
  },
];

const CreateProjectNavigation = ({
  activeStep,
  setActiveStep,
}) => {
  return (
    <div className="border-b border-slate-200 bg-white px-6">

      <div className="flex gap-7 overflow-x-auto">

        {tabs.map((tab) => {
          const Icon = tab.icon;

          const active = activeStep === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveStep(tab.id)}
              className={`relative flex items-center gap-2 whitespace-nowrap py-4 text-sm font-semibold transition-colors ${
                active
                  ? "text-blue-600"
                  : "text-slate-500 hover:text-slate-700"
              }`}
            >

              <Icon size={17} />

              {tab.label}

              {active && (
                <span className="absolute bottom-0 left-0 h-[3px] w-full rounded-full bg-blue-600" />
              )}

            </button>
          );
        })}

      </div>

    </div>
  );
};

export default CreateProjectNavigation;